/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CoreModule
 */

import {
    Component,
    Injectable,
    Type,
} from '@angular/core';

import { ObservableList } from 'nsx-alb-ui-components';

/**
 * Interface to represent props required to render app level alert.
 */
export interface IAviAppLevelAlertsProps {
    id: string;
    component?: Type<Component>;
    componentProps?: Record<string, any>;
}

/**
 * @description Service for adding and removing app level alerts.
 * @author Nisar Nadaf
 */
@Injectable({
    providedIn: 'root',
})
export class AppLevelAlertsService extends ObservableList<IAviAppLevelAlertsProps, string> {
    protected getID(item: IAviAppLevelAlertsProps): string {
        return item.id;
    }
}
